// index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // This should match the exported default component

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
